const ms = {
  task: {
    center: "Pusat tugas",
    callTask: "Tugas panggilan",
    giftTask: "Tugas hadiah",
    liveTask: "Tugas pendatang baru",
    sevenTask: "Tugas 7 hari",
    callMessage: "Panggil lebih banyak untuk mendapatkan ganjaran",
    giftMessage: "Terima hadiah untuk mendapat hadiah",
    liveMessage: "Tingkatkan jangka masa Live untuk mendapat ganjaran {d}",
    sevenMessage: "Selesaikan tugas harian untuk mendapat ganjaran {d}",
    cellTitle: "Panggil ≥{d} minit (kali):",
    reward: "Ganjaran",
    lastWeek: "Ganjaran minggu lalu::",
    weekGift: "Hasil hadiah mingguan:",
    RewardDescription: "Arahan ganjaran",
    everyWeekGift: "Hasil hadiah mingguan <span class='web'>(Bonus)</span>",
    endTask: 'Tugas selesai',
    query: "okey"
  },
  message: {
    taxt1: "1. Setiap kitaran penyelesaian adalah dari hari Isnin hingga Ahad. Semakin lama tempoh panggilan video ≥{d} minit, semakin banyak hadiahnya.",
    taxt2: "2. Anda hanya boleh mendapat ganjaran satu tahap setiap minggu, berdasarkan penilaian masa tempoh panggilan tunggal anda pada minggu itu ≥{d} minit",
    taxt3: "3. Selepas pengesahan rasmi, ganjaran akan dikeluarkan ke akaun anda sebelum Khamis depan selepas penyelesaian",
    taxt4: "4. Sekiranya berlaku kecurangan, anda akan hilang kelayakan untuk mendapatkan sebarang hadiah",
    taxt5: "5. Sekiranya anda mempunyai sebarang pertanyaan, sila hubungi：<span class='web'>support@honeycamweb.com</span>",
    hint: "Catatan: Tertakluk pada waktu antarabangsa",
    rewardOne1: "1.Dalam masa 7 hari selepas tugas dimulakan",
    rewardOne2: "1) Live≥2 jam dan kadar penyelesaian panggilan ≥{d} sehari selama sekurang-kurangnya 6 hari;",
    rewardOne3: "2) Dalam 7 hari selepas tugas dimulakan, jumlah pendapatan mencapai ≥{d}Bonus;",
    rewardOne4: "3) Sekiranya syarat di atas dipenuhi pada masa yang sama, anda boleh mendapat ganjaran <span style='color: #ff2794'>{d}</span> dari platform setelah tugas berakhir;",
    rewardOne5: "2.Penanda dapat memberi ganjaran maksimum satu akaun, dan banyak akaun tidak sah;",
    rewardOne6: "3.Sekiranya berlaku kecurangan, kelayakan untuk mendapat ganjaran akan dibatalkan;",
    rewardOne7: "4.Pengguna yang menyelesaikan tugas, setelah tugas selesai. Ikuti halaman utama <span class='web' style='color: #f99634'>Facebook \"Honeycam\"</span> rasmi, dan tambahkan kumpulan untuk mendapat hadiah <span style='color: #ff2794'>$10</span>;",
    rewardOne8: "5.Sekiranya anda mempunyai sebarang pertanyaan, sila hubungi：<span class='web'>support@honeycamweb.com;</span>",
    rewardTwo1: "Pengguna yang memperoleh lebih dari {d} pada hari semasa misi akan berpeluang memasuki kedudukan teratas halaman yang disarankan atau popular pada hari berikutnya untuk mendapat lebih banyak pendedahan;"
  },
  gift: {
    test1: "1. Kitaran penyelesaian adalah dari hari Isnin hingga Ahad. Semakin banyak hadiah yang anda dapat, semakin banyak hadiah.",
    test2: "2. Anda hanya boleh mendapat ganjaran untuk satu tahap setiap minggu, dan tahapnya dinilai berdasarkan jumlah pendapatan minggu itu.",
    test3: "3. Setelah pengesahan rasmi, ganjaran akan dikeluarkan ke akaun hasil anda sebelum hari Khamis depan.",
    test4: "4. Sekiranya berlaku kecurangan, anda akan hilang kelayakan untuk mendapatkan sebarang hadiah",
    test5: "5. Sekiranya anda mempunyai sebarang pertanyaan, sila hubungi：<span class='web'>support@honeycamweb.com</span>",
    giftNum: "Hadiah yang diterima ≥{d}",
    totalBonus: "Pendapatan ≥{d}Bonus",
    liveCallTime: "<span class='web'>live</span>≥{d}(m)",
    callTime: "Panggil ≥{d}(m)",
    callRate: "接通率≥{d}%"
  },
  new: {
    rewardOne: "Ganjaran Satu",
    rewardTwo: "Ganjaran Dua",
    start: "Tugas dibuka secara rasmi pada pukul 0:00 hari ini",
    hint: "Kekal Live≥{d} jam dan kadar penyelesaian panggilan ≥{d} sehari.Anda boleh mendapat ganjaran {d}.",
    tastReward: "Jumlah pendapatan <span class='web'>Bonus</span> semasa misi",
    liveTime: "Tempoh Live hari ini",
    callRate: "Kadar penyelesaian panggilan untuk hari ini",
    progress: "Kemajuan tugas",
    endRate: "(sasaran ≥",
    overText1: "Selamat menyelesaikan tugas.Selamat menyelesaikan tugas",
    overText2: "Ikuti <span class='web'>Facebook \"Honeycam\"</span> dan tambahkan kumpulan untuk mendapat hadiah {d}.",
    overText3: "Sayang sekali bahawa tugas itu tidak diselesaikan dan anda tidak dapat memperoleh hadiah {d}.",
    overText4: "Ikuti <span class='web'>Facebook \"Honeycam\"</span> untuk mendapatkan lebih banyak maklumat mengenai tugas.",
    openfb: "Buka <span class='web'>Facebook</span>",
  },
  week: {
    live30: "Esok Live≥{d} minit",
    call5: "Panggilan esok ≥5 minit",
    rewardHint: "(Sekiranya semua tugas berikut selesai,<span style='color: #ff2794'>anda akan mendapat ganjaran tambahan<span class='web'>$20</span></span>)",
    newLive: "Siaran Live",
    newLiveSec: "(sasaran ≥{d})",
    newCall: "Panggilan Hari Ini",
    newCallRate: "Kadar penyelesaian panggilan untuk hari ini",
    newBonus: "Pendapatan hari ini Bonsu",
    newGift: "Jumlah hadiah hari ini",
    newReward: "Hadiah hari ini",
    days: "Hari",
    taskReq: "Keperluan tugas",
    task1: "1.Tugas setiap hari diselesaikan pada pukul 0:00, dan dikeluarkan ke akaun Bonus anda pada pukul 0:00;",
    task2: "2.Sekiranya tugas itu tidak diselesaikan pada hari itu, ia akan gagal. Tugas yang gagal tidak dapat disambung semula;",
    task3: "3.Hanya semua tugas 7 hari selesai, pakej ganjaran $20 dapat diperoleh; ",
    task4: "4.Penanda dapat memberi ganjaran maksimum satu akaun, dan banyak akaun tidak sah; ",
    task5: "5.Sekiranya berlaku kecurangan, kelayakan untuk mendapat ganjaran akan dibatalkan;",
    task6: "6.Pengguna yang menyelesaikan tugas, setelah tugas selesai. Ikuti laman utama <span class='web' style='color: #f99634'>Facebook \"Honeycam\"</span> \"rasmi, dan tambahkan kumpulan untuk mendapat hadiah <span style='color: #ff2794' class='web'>$20</span>;",
    task7: "7.Sekiranya anda mempunyai sebarang pertanyaan, sila hubungi：<span class='web'>support@honeycamweb.com;</span>",
  }
};

export default ms;
